import { ProductLookUpPrice, ProductLookUpPriceProps } from "./ProductLookUpPrice";

export interface ProductLookUpProps {
  productId: number;
  productKey: string;
  itemName: string;
  itemDescription: string | null;
  upcItemNumber: string | null;
  glItemNumber: string | null;
  glItemDescription: string | null;
  categoryId: number | null;
  categoryName: string | null;
  categoryKey: string | null;
  categoryDescription: string | null;
  prices: ProductLookUpPriceProps[];
}

export class ProductLookUp {
  private readonly _productId: number;
  private readonly _productKey: string;
  private readonly _itemName: string;
  private readonly _itemDescription: string | null;
  private readonly _upcItemNumber: string | null;
  private readonly _glItemNumber: string | null;
  private readonly _glItemDescription: string | null;
  private readonly _categoryId: number | null;
  private readonly _categoryName: string | null;
  private readonly _categoryKey: string | null;
  private readonly _categoryDescription: string | null;
  private readonly _prices: ProductLookUpPrice[];

  constructor(props: ProductLookUpProps) {
    this._productId = props.productId;
    this._productKey = props.productKey;
    this._itemName = props.itemName;
    this._itemDescription = props.itemDescription;
    this._upcItemNumber = props.upcItemNumber;
    this._glItemNumber = props.glItemNumber;
    this._glItemDescription = props.glItemDescription;
    this._categoryId = props.categoryId;
    this._categoryName = props.categoryName;
    this._categoryKey = props.categoryKey;
    this._categoryDescription = props.categoryDescription;
    this._prices = (props.prices ?? []).map(price => new ProductLookUpPrice(price));
  }

  public get productId(): number {
    return this._productId;
  }

  public get productKey(): string {
    return this._productKey;
  }

  public get itemName(): string {
    return this._itemName;
  }

  public get itemDescription(): string | null {
    return this._itemDescription;
  }

  public get upcItemNumber(): string | null {
    return this._upcItemNumber;
  }

  public get glItemNumber(): string | null {
    return this._glItemNumber;
  }

  public get glItemDescription(): string | null {
    return this._glItemDescription;
  }

  public get categoryId(): number | null {
    return this._categoryId;
  }

  public get categoryName(): string | null {
    return this._categoryName;
  }

  public get categoryKey(): string | null {
    return this._categoryKey;
  }

  public get categoryDescription(): string | null {
    return this._categoryDescription;
  }

  public get prices(): ProductLookUpPrice[] {
    return this._prices;
  }
}
